<lcs-loading-overlay
  class="flex-dir-col"
  [show]="callState | lcsCallState : 'loading'"
  *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Prompt'"
  >
  <div class="detail-page-headerbar">
    <div class="left">
      <div class="page-heading">
        <h2 class="page-title">Prompt - {{ prompt?.name }}</h2>
      </div>
    </div>
    <button
      type="button"
      mat-button
      [matMenuTriggerFor]="updateDetailsMenu"
      matTooltip="Info"
      aria-label="Prompt Info"
      id="extension-detail-info"
      >
      <mat-icon>info</mat-icon>
    </button>
    @if (promptPrivileges.canDelete) {
      <button
        type="button"
        mat-button
        [matMenuTriggerFor]="promptMenu"
        aria-label="Prompt Actions"
        matTooltip="More Actions"
        id="prompt-detail-more-actions"
        >
        <mat-icon>more_horiz</mat-icon>
      </button>
    }
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <ndt-two-column-layout>
      <div ndtLeftColumn>
        <div class="details-wrapper">
          @if (prompt?.name) {
            <h5>Name</h5>
            <div class="detail-item">{{ prompt.name }}</div>
          }
          @if (prompt?.typeId && prompt?.account?.accountId) {
            <h5>Type</h5>
            <div class="detail-item typeId">{{ prompt?.typeId | addSpaces }}</div>
          }
          @if (prompt?.typeId && prompt?.account?.accountId) {
            <h5>File</h5>
            <div class="detail-item typeId">{{ prompt?.file?.displayName }}</div>
          }
        </div>
      </div>
      <div ndtRightColumn>
        <div class="detail-right-column">
          <mat-form-field class="flex-half">
            <mat-label>Name</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              [value]="prompt?.name"
              formControlName="name"
              id="name"
              required
              />@if (form.get('name')?.hasError('required')) {
              <mat-error>Name is required. </mat-error>
            }
            @if (form.get('name')?.hasError('pattern')) {
              <mat-error>
                Name has incorrect pattern. Must contain characters</mat-error
                >
            }
          </mat-form-field>
          @if (isSystemUser) {
            <mat-form-field class="flex-half">
              <mat-label>Type</mat-label>
              @if (isMusicOnHoldType === true) {
                <ng-container class="flex-full">
                  <input matInput type="text" id="typeId" value="Music On Hold" readonly />
                </ng-container>
              } @else {
                <input
                  ndtPromptTypeSelect
                  autocomplete="off"
                  type="text"
                  [lcsSingleSelect]="promptTypeSelect"
                  ndtPromptTypeSelect
                  formControlName="typeId"
                  id="typeId"
                  required
                  />
                  <ndt-prompt-type-select
                    #promptTypeSelect
                    [excludedPromptTypes]="['SystemPrompt']"
                    ></ndt-prompt-type-select
                    >@if (form.get('typeId')?.hasError('required')) {
                    <mat-error>Prompt Type is required.</mat-error>
                  }
                }
              </mat-form-field>
            }
            <div class="flex-half">
              <div class="flex-full">
                @if (prompt?.file && reloadAudio) {
                  <audio
                    #audio
                    controls
                    class="prompt-audio-player"
                    >
                    <source [src]="prompt?.file?.fileToken | fileUrl" (error)="onFileNotFound($event)" />
                  </audio>
                } @else {
                  <span>File not found, please upload a new file</span>
                }
                @if (fileNotFound === true) {
                  <mat-error matError>Failed to load audio file</mat-error>
                  }</div
                  >
                </div>
                <mat-checkbox
                  class="flex-half center-prompt-checkbox"
                  [checked]="prompt?.isActive"
                  formControlName="isActive"
                  id="isActive"
                  >Active</mat-checkbox
                  >
                  <div class="button-container">
                    <button
                      class="change-prompt-button"
                      type="button"
                      title="Change Prompt File"
                      mat-raised-button
                      (click)="changePromptFile()"
                      >Change Prompt File</button
                      >
                    </div>
                  </div>
                </div>
              </ndt-two-column-layout>
              <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
            </form>
          </lcs-loading-overlay>
          <mat-menu #promptMenu="matMenu">
            @if (promptPrivileges.canDelete) {
              <button
                mat-menu-item
                type="button"
                (click)="onDeleteClick()"
                id="menu-prompt-delete"
                >
                Delete
              </button>
            }
          </mat-menu>
          <mat-menu #updateDetailsMenu="matMenu">
            <update-details
              [createUser]="prompt?.createUser"
              [createDate]="prompt?.createDate"
              [updateUser]="prompt?.updateUser"
              [updateDate]="prompt?.updateDate"
            ></update-details>
          </mat-menu>
